module.exports = __webpack_public_path__ + "static/media/lock_icon.639a3d2e.svg";